module.exports = __webpack_public_path__ + "media/images/manage-offer/folder-8fb0b4ae2839629389dd704cf29a3115.png";